import React from 'react';
import PropTypes from 'prop-types';
import GameProp from '../propTypes/gameProp';
import translate from '../../../commonComponents/translate';
import InfoContent from './info/InfoContent';
import RewardInfo from './info/RewardInfo';

function Info({ challenge }) {
  return (
    <>
      <div className="about-tab">
        <InfoContent challenge={challenge} />
        <RewardInfo challenge={challenge} />
      </div>
    </>
  );
}

Info.propTypes = {
  challenge: PropTypes.shape(GameProp.propType).isRequired,
};

export default translate(Info);
